import { loadModules } from 'esri-loader';
import { requestApi } from "../../form/utilities";
import { QueryTask, CenterAndZoom } from "./queryTask";
import { GeometryEngineTask } from "./geometryEngineTask";
import { getEnvVariable } from "../../../../modules/environmentalList";

export function AddLayers(view, config, mapdata, mapkey, mapConstants, SubModuleKey, layersList, statusList, isOnlyRecord= false) {
  return new Promise((resolve, reject) => {
    if (!loadModules) {
      reject("AddLayers: ArcGIS API is not loaded");
      return;
    }

    AddingLayers(view, config, mapdata, mapkey, mapConstants, SubModuleKey, layersList, statusList, isOnlyRecord).then(
      (response) => {
        resolve(response);
      },
      (error) => {
        reject(error);
      }
    );
  });
}

export function getpermittypeSymbol(permitTypecolor, statusColor) {
  const defaultSym = {
    type: "simple-marker", // autocasts as new SimpleMarkerSymbol()
    style: "circle", color: statusColor || permitTypecolor, size: "10px", // 
    outline: { // autocasts as new SimpleLineSymbol() 
      color: statusColor || permitTypecolor, width: 3 // points
    }
  }  
  return defaultSym;
}

export function getHighlightSymol() {
  let highlightrenderer = {
    type: "simple-marker", // autocasts as new SimpleMarkerSymbol()
    color: "yellow",
    size: 8,
    outline: {
      // autocasts as new SimpleLineSymbol()
      width: 0.5,
      color: "darkyellow",
    },
  };
  return highlightrenderer;
}

export function getHighlightSymolColor(color) {
  let highlightrenderer = {
    type: "simple-marker", // autocasts as new SimpleMarkerSymbol()
    color: color || "yellow",
    size: 8,
    outline: {
      // autocasts as new SimpleLineSymbol()
      width: 0.5,
      color: color || "darkyellow",
    },
  };
  return highlightrenderer;
}

function GetLayerRequestURL(layerurl) {
  try {
    if(layerurl){
      let url = layerurl.split('/query?')[0];
      return url;
    }  
  } catch (error) {    
    console.log('error', error);
  }
  return layerurl;  
}

function GetLayerRequestQueryWhere(layerurl) {
  try {
    if(layerurl){
      let url = layerurl.split('/query?where=')[1];
      return url;
    }  
  } catch (error) {    
    console.log('error', error);
  }
  return null;  
}

function getSysteDefaultExpressions(layerinfo) {
  return GetLayerRequestQueryWhere(layerinfo.url);  
}


function AddingLayers(view, layers, mapdata, mapkey, mapConstants, SubModuleKey, res, statusres, isOnlyRecord= false) {
  return new Promise((resolve, reject) => {
    loadModules([
      "esri/layers/GraphicsLayer",
      "esri/layers/FeatureLayer",
      "esri/PopupTemplate",
      "esri/layers/MapImageLayer",
      "esri/config",
      "esri/layers/ImageryLayer",
      "esri/layers/TileLayer",
      "esri/symbols/SimpleFillSymbol",
      "esri/layers/GroupLayer",
    ]).then(([GraphicsLayer, FeatureLayer, PopupTemplate, MapImageLayer, esriConfig, ImageryLayer, TileLayer, SimpleFillSymbol, GroupLayer]) => {
      let highlight;      
      if (layers && view && layers.length > 0) {       
        let layerstopresent = []
        if(isOnlyRecord){
          layers = layers.filter(layer => layer.IsRecord === 'Y' || layer.key === 'CenterGeomService' ||  layer.key == "RECORD_HIGHLIGHT_LAYER");
        }
        layers.forEach(function (lyrinfo, indx) {
          let layer = null;
          if (lyrinfo.HasAuthentication == "Y" && lyrinfo.Token) {               
            const requrl =  lyrinfo.url.includes('/Adopt_a_Highway_Network/') ? GetLayerRequestURL(lyrinfo.url) : lyrinfo.url;            
            esriConfig.request.interceptors.push({
              urls: requrl,
              before: function (params) {   
                if(params?.requestOptions?.query){
                  params.requestOptions.query.token = lyrinfo.Token;
                  params.requestOptions.query.expiration = lyrinfo.TokenExpiration;               
                  params.requestOptions.query = params.requestOptions.query || {};
                }
              }
            });
          }

          if (lyrinfo && lyrinfo.url && lyrinfo.url !== "") {
            let labelClass = null;
            if (lyrinfo.showLabels && lyrinfo.labelExpression) {
              labelClass = { ...mapConstants.labelClass }
              //labelClass.labelExpression=lyrinfo.labelExpression
              labelClass.labelExpressionInfo = {
                expression: lyrinfo.labelExpression
              }
              if (lyrinfo.labelColor) {
                labelClass.symbol.color = lyrinfo.labelColor
              }
            }
            //  console.log('layer url------------', lyrinfo.url);
            switch (lyrinfo.type) {
              case "F": //F-FeatureLayer
              case "A": //F-FeatureLayer
                layer = new FeatureLayer({
                  title: lyrinfo.title,
                  url: lyrinfo.url,
                  id: lyrinfo.id,
                  LayerOptions: lyrinfo,
                  visible: (lyrinfo.ShowOnMap === "Y")
                }); //
                break;
              case "G": //G-GraphicsLayer
                layer = new GraphicsLayer({
                  title: lyrinfo.title,
                  url: lyrinfo.url,
                  LayerOptions: lyrinfo,
                  visible: (lyrinfo.ShowOnMap === "Y")
                });
                break;
              case "M": //G-GraphicsLayer
                layer = new MapImageLayer({
                  url: lyrinfo.url,                  
                  highlightOptions: {
                    color: [255, 222, 173],
                    fillOpacity: 0.1,
                  },
                  LayerOptions: lyrinfo,
                  visible: (lyrinfo.ShowOnMap === "Y")
                });
                break;
                case "I": //I-ImageryLayer
                layer = new ImageryLayer({
                  title: lyrinfo.title,
                  url: lyrinfo.url,
                  LayerOptions: lyrinfo,
                  visible: (lyrinfo.ShowOnMap === "Y")
                });
                break;
                case "T": //T-TileLayer
                layer = new TileLayer({
                  title: lyrinfo.title + '-Tile',
                  url: lyrinfo.url,   
                  LayerOptions: lyrinfo,                  
                  visible: (lyrinfo.ShowOnMap == "Y"),
                  spatialReference: { wkid: 102100 }             
                });
                break;
                default:
                  console.log(`No Layer type found`);
                  layer = new FeatureLayer({
                    title: lyrinfo.title,
                    url: lyrinfo.url,
                    id: lyrinfo.id,
                    LayerOptions: lyrinfo,
                    visible: (lyrinfo.ShowOnMap == "Y")
                  });
            }
            let adoptingLinkRegistery = "<b><a href='https://development.delasoft.com:8543/MPS-auth-UI/login/default?usetype=E&ENV=MPS-8543-external&Signup=Y' target='_blank'>Register to Adopt </a></b> ";
            if (layer) {
              // Add layer info template to the layer.
              let title = lyrinfo.title || lyrinfo.key;
              if (lyrinfo.key == "CenterGeomService" || lyrinfo.IsRecord == 'Y' || lyrinfo.key == "RECORD_HIGHLIGHT_LAYER") {
                if (SubModuleKey == "COLLISION")
                  title = "Record Info  " + "<b><a href='#/Records/{SubModuleKey}/{Site_Permit_Type_Id}/{ObjectId}' >View Collision </a></b> " + " / " + "<b><a href='#/Records/{SubModuleKey}/{Site_Permit_Type_Id}/{Investigation_Id}' > Investigation </a></b> ";
                else
                  title = "Record Info  " + "<b><a href='#/Records/{SubModuleKey}/{Site_Permit_Type_Id}/{ObjectId}' >View Details </a></b> ";
              }  
              var popupTemplateContent;
              if (lyrinfo.InfoTemplate) {
                popupTemplateContent = lyrinfo.InfoTemplate;
              }
              if (popupTemplateContent) {
                const { expressionInfos, fieldInfos, linkfields } = formatPopupContent(popupTemplateContent);
                
                let titleHTML = "Links:<p></p><br>";
                linkfields.forEach(field => {
                  console.log('field', field.value);
                  titleHTML += "<p>"+ field.value + "<br></p>";
                });                
                
                let popupTemplate = new PopupTemplate({                  
                  title: title + "<br>" + titleHTML + "<br>" + adoptingLinkRegistery,
                  content: [{
                    type: "fields",
                    fieldInfos: fieldInfos
                  }],
                  expressionInfos: expressionInfos
                });
                layer.popupTemplate = popupTemplate;
              }

              // Only for one layer to show pins
              if (lyrinfo.key === "CenterGeomService" || lyrinfo.IsRecord === 'Y') {
                let title;
                if (mapkey && mapkey.includes("EPS_map")) {
                  if (SubModuleKey == "COLLISION")
                    title = "Record Info  " + "<b><a href='#/Records/{SubModuleKey}/{Site_Permit_Type_Id}/{ObjectId}' >View Collision </a></b> " + " / " + "<b><a href='#/Records/{SubModuleKey}/{Site_Permit_Type_Id}/{Investigation_Id}' > Investigation </a></b> ";
                  else
                    title = "Record Info  " + "<b><a href='#/Records/{SubModuleKey}/{Site_Permit_Type_Id}/{ObjectId}' >View Details </a></b> ";
                }
                else title = "Record Info";
                var popupTemplateContent;
                if (lyrinfo.InfoTemplate) {
                  popupTemplateContent = lyrinfo.InfoTemplate;
                }
                if (popupTemplateContent) {
                  let popupTemplate = new PopupTemplate({
                    // autocasts as new PopupTemplate()
                    title: title + adoptingLinkRegistery,
                    content: popupTemplateContent,
                  });
                  layer.popupTemplate = popupTemplate;
                }                
              }else if (lyrinfo.url.includes('/Adopt_a_Highway_Network/') && lyrinfo.Name.includes("_AAH_")){
                  layer.definitionExpression = getSysteDefaultExpressions(lyrinfo); 
                  layer.renderer = AAH_Renderer();                  
              }else if (lyrinfo.url.includes('/Adopt_a_Highway_Network/') && lyrinfo.Name.includes("_SPONSOR_")){
                // Highlight render with unique values
                layer.definitionExpression = getSysteDefaultExpressions(lyrinfo);                
                layer.renderer = AAH_Renderer();
              }
              else {

                let title = lyrinfo.title || lyrinfo.key;
                let popupTemplateContent;
                if (lyrinfo.InfoTemplate) {
                  popupTemplateContent = lyrinfo.InfoTemplate;
                }
                if (popupTemplateContent) {
                  const { expressionInfos, fieldInfos, linkfields } = formatPopupContent(popupTemplateContent);
                  
                  let titleHTML = "";
                  linkfields.forEach(field => {
                    console.log('field', field.value);
                    titleHTML += "<b> "+ field.label +" Link </b>:"+ field.value + "<br>";
                  });                
  
                  let popupTemplate = new PopupTemplate({                  
                    title: (linkfields.length > 0 ?  title + "<br>" + titleHTML : title) + "<br>" + adoptingLinkRegistery,
                    content: [{
                      type: "fields",
                      fieldInfos: fieldInfos
                    }],
                    expressionInfos: expressionInfos
                    // content: function(feature) {
                    //   return generatePopupContent(feature.graphic, fieldInfos, linkfields);
                    // },
                    // expressionInfos: expressionInfos
                  });
                  layer.popupTemplate = popupTemplate;                                    
                }

                //console.log(layer, layer.renderer)

              }

              if (lyrinfo.outFields)
                layer.outFields = lyrinfo.outFields || ["*"];

              //When layer loaded set color
              layer && layer.when(function () {
                if (lyrinfo.LayerColor && layer.renderer && layer.renderer.symbol && layer.renderer.symbol.outline) {
                  //layer.renderer.symbol.color = lyrinfo.HighlightColor;
                  //layer.renderer.symbol.outline.color = lyrinfo.LayerColor;
                  layer.renderer.symbol = new SimpleFillSymbol({
                    color: hexToRgba(lyrinfo.LayerColor, 0.5),
                    outline: {
                      color: lyrinfo.HighlightColor || '#cdf7d5', // Black outline
                      width: 1
                    }
                  });
                }
              });

              if (layer && lyrinfo.ExtentZoom === true) {
                layer.when(function () {
                  //console.log("layer loaded------------------", layer);
                  // view.goTo(layer.fullExtent);
                });
              }
              //Set Layer Scale Beyond
              if (lyrinfo.LayerScaleType == 'Z') {
                layer.minScale = lyrinfo.ScaleInBeyond;
                layer.maxScale = lyrinfo.ScaleOutBeyond;
              }

              if (Array.isArray(mapdata) && mapdata.length > 0 && (lyrinfo.key == "CenterGeomService" || lyrinfo.IsRecord == 'Y')) {
                let expression = "Id in (" + mapdata.toString() + ")";
                //let expression = lyrinfo.defaultExpression || "1=1";
                layer.definitionExpression = expression;
              } else {
                let expression = lyrinfo.defaultExpression || "1=1";
                layer.definitionExpression = expression;
              }
              if (lyrinfo.showLabels) {
                layer.labelingInfo = [labelClass];
                layer.labelsVisible = lyrinfo.showLabels;
              }

              view.graphics.removeAll();
              // let existinglayer = view.map.layers.find(function (elayer) {
              //   return elayer.title === layer.title;
              // });
              // if (existinglayer) {
              //   //view.map.layers.remove(existinglayer)
              //   findAndRemoveLayer(layer.title, view.map)
              // }

              if (lyrinfo.IsRecord == "Y" && lyrinfo.key !== "CenterGeomService") {
                let userdefinitions = GetRecordQueryExpressions(lyrinfo);
                if (userdefinitions && SubModuleKey)
                  layer.definitionExpression = " SubModuleKey = '" + SubModuleKey + "' AND " + userdefinitions
                else if (!userdefinitions && SubModuleKey)
                  layer.definitionExpression = " SubModuleKey = '" + SubModuleKey + "'";
                else if (!SubModuleKey && userdefinitions)
                  layer.definitionExpression = userdefinitions

                if (Array.isArray(mapdata) && mapdata.length > 0) {
                  let expression = "ID in(" + mapdata.toString() + ")";
                  if (expression) {
                    layer.definitionExpression = layer.definitionExpression + " AND " + expression
                  }
                }
              }

              if (lyrinfo.key == "CenterGeomService" && lyrinfo.IsRecord != "Y") {
                let userdefinitions = GetRecordQueryExpressions(lyrinfo);
                layer.definitionExpression = userdefinitions
              }

              // //Adding layers to the list here
              // view.map.layers.add(layer, indx);
              layerstopresent.push(layer);

              //group layers by layer name having - in it. Example NPTS - LayerName. Group name will be NPTS
              let layername = lyrinfo.title;
              let groupname = layername.split('-')[0].trim();              
              let groupLayer = view.map.findLayerById(groupname);              
              //do not include groupname in title
              layer.title = (layername.includes('-')) ? layername.split('-')[1].trim() : layername;
              findAndRemoveLayer(layer.title, view.map)
              if (groupLayer) {                
                groupLayer.layers.add(layer);
              } else {
                //check layer has group name in it and add it to group layer else as single layer
                if (layername.includes('-')) {                 
                  groupLayer = new GroupLayer({
                    id: groupname,
                    title: groupname,
                    visible: false
                  });                  
                  groupLayer.layers.add(layer);                  
                  view.map.add(groupLayer, indx);
                }else{
                  view.map.add(layer, indx);
                }                
              }

            }
          }
        });
        setTimeout(() => {
          resolve(true);
        }, 300);
        //   });       
      } else {
        resolve(true);
      }

    });
  });
}

function findAndRemoveLayer(layerTitle, group) {
  try {
    for (let i = group.layers.length - 1; i >= 0; i--) {
      let elayer = group.layers.getItemAt(i);

      if (elayer.title === layerTitle) {
        console.log('LAYER REMOVED-----' + layerTitle);
        group.layers.remove(elayer);
        return; // Stop further processing once the layer is removed
      } else if (elayer.type === "group") {
        console.log('GROUP FOUND-----' + elayer.title);
        findAndRemoveLayer(layerTitle, elayer); // Recursively search within groups
      }
    }
  } catch (ex) {
    console.error('Error removing layer:', ex);
  }
}


function formatPopupContent(content) {
  const urlPattern = /(https?:\/\/[^\s]+)/g;
  let expressionInfos = [];
  let fieldInfos = [];
  let linkfields = [];

  content.forEach(info => {
    if (info.type === "fields") {
      const firstFieldName = info.fieldInfos[0].fieldName;
      info.fieldInfos.forEach(fieldInfo => {
        let value = fieldInfo.value || "";
        const match = value.match(urlPattern);
        if (match) {          
          // let reflink = fieldInfo.value + '{' + fieldInfo.fieldName + '}';
          // linkfields.push({
          //   fieldName: fieldInfo.fieldName,
          //   label: fieldInfo.label,
          //   value: fieldInfo.value
          //   //`"<a href='" + $feature.${fieldInfo.fieldName} + "' target='_blank'>This" + $feature.${fieldInfo.fieldName} + "</a>"`
          // });
          // fieldInfos.push({
          //   fieldName: `${fieldInfo.fieldName}`,
          //   label: fieldInfo.label
          // });
          expressionInfos.push({
            name: `${fieldInfo.fieldName}_Link`,
            title: fieldInfo.label,
            expression: `
              IIF($feature.${fieldInfo.fieldName} == 'Y', 
              "${fieldInfo.value}"+$feature.${firstFieldName}, 
              "NA")
            `
          });
          fieldInfos.push({
            fieldName: `expression/${fieldInfo.fieldName}_Link`,
            label: fieldInfo.label+"_Link"
          });
        } else {
          fieldInfos.push({
            fieldName: fieldInfo.fieldName,
            label: fieldInfo.label
          });
          // if (fieldInfo.fieldName === 'HAS_FILE') {
          //   expressionInfos.push({
          //     name: `${fieldInfo.fieldName}_Link`,
          //     title: fieldInfo.label,
          //     expression: `
          //       IIF($feature.${fieldInfo.fieldName} == 'Y', 
          //       "https://myurl.com/{$feature.OBJECTID}", 
          //       "No")
          //     `
          //   });
          //   fieldInfos.push({
          //     fieldName: `expression/${fieldInfo.fieldName}_Link`,
          //     label: fieldInfo.label+"_Link"
          //   });
          // } else {
          //   fieldInfos.push({
          //     fieldName: fieldInfo.fieldName,
          //     label: fieldInfo.label
          //   });
          // }
        }
      });
    }
  });
//console.log('refcontent', expressionInfos, fieldInfos, linkfields);
  return { expressionInfos, fieldInfos, linkfields };
}


function GetRecordQueryExpressions(layerinfo) {
  let profile = localStorage.getItem('profile') && JSON.parse(localStorage.getItem('profile'))
  let defaultLayerExpression = layerinfo.defaultExpression;
  let layerDefinitionExpressionFilter;

  if (profile) {
    let isInternal = profile && profile.portal == "I";
    if (isInternal) {
      let districts = profile && profile.moduleDistrictAccess && Object.keys(profile.moduleDistrictAccess) || [];
      if (Array.isArray(districts) && districts.length > 0) {
        layerDefinitionExpressionFilter = " District_Id in (" + districts.join(",") + ")";
      }
    } else {
      layerDefinitionExpressionFilter = " Owner ='" + profile.modulePermissions[0].companyId + "'";
    }
  }
  let layerDefinitionExpression = (!layerDefinitionExpressionFilter || layerDefinitionExpressionFilter == "()" || layerDefinitionExpressionFilter == "1=1") ? (defaultLayerExpression) : (("(" + defaultLayerExpression + ")") + " and " + layerDefinitionExpressionFilter);
  return layerDefinitionExpression;
}

function AAH_Renderer() {
  return {
    type: "unique-value",
    field: "Status",
    valueExpression: `
      var status = $feature.Status;
      var cardinality = $feature.RouteCardinality;
      if (cardinality == 'Y' && (status == 'available' || status == 'sponsor available')) {
        return 'cardiancheck';
      }
      return status;
    `,
    uniqueValueInfos: [
      {
        value: "available",
        symbol: {
          type: "simple-line",  
          color: "green",
          width: "4px",  
          style: "solid"  
        }
      },
      {
        value: "adopted",
        symbol: {
          type: "simple-line",  
          color: "#ae33f5",
          width: "4px",  
          style: "solid"  
        }
      },
      {
        value: "unavailable",
        symbol: {
          type: "simple-line",  
          color: "red",
          width: "4px",  
          style: "solid" 
        }        
      },
      {
        value: "sponsor available",
        symbol: {
          type: "simple-line", 
          color: "green",
          width: "4px",  
          style: "solid" 
        }
      },
      {
        value: "sponsor taken",
        symbol: {
          type: "simple-line",  
          color: "#ae33f5",
          width: "4px",  
          style: "solid" 
        }        
      },   
      {
        value: "cardiancheck",
        symbol: {
          type: "simple-line",  
          color: "#39FF14",
          width: "4px",  
          style: "solid" 
        }
      }                 
    ],
    defaultSymbol: {
      type: "simple-line",
      color: "gray",
      width: "4px",
      style: "solid"
    }
  };
}


function hexToRgba (hex, alpha) {
  try {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  } catch (error) {
    console.log('error', error);    
  }
  return hex;
}

/*
function getTitle(feature)
{
  if (feature.graphic.attributes.SubModuleKey=="COLLISION")
  {
    return "Record T Info  " + "<b><a href='#/Records/{SubModuleKey}/{Site_Permit_Type_Id}/{ObjectId}' >View Collision </a></b> "+" / " + "<b><a href='#/Records/{SubModuleKey}/{Site_Permit_Type_Id}/{Investigation_Id}' > Investigation </a></b> ";
  }
  else
  {
  return  "Record Info  " + "<b><a href='#/Records/{SubModuleKey}/{Site_Permit_Type_Id}/{ObjectId}' >View Details </a></b> ";
  }
}*/